import { ActionIcon, Group, Text, TextInput } from "@mantine/core";
import { IconCheck, IconEdit } from "@tabler/icons-react";
import { useState } from "react";
import { editList } from "../../../../../api/ContactAPI";
import { useClickOutside } from "@mantine/hooks";
import { useListStore } from "../../../../../stores/ListStore";
import { editBlacklist } from "../../../../../api/BlacklistAPI";

const ListName = ({ currentList, onRenamed, isBlacklist }) => {
  const setListingLoad = useListStore((s) => s.setListingLoad);

  const [isEdit, setIsEdit] = useState(false);
  const [name, setName] = useState(currentList?.name);
  const [loading, setLoading] = useState(false);

  const ref = useClickOutside(() => setIsEdit(false));

  const handleClick = () => {
    setIsEdit(true);
    setName(currentList?.name);
  };

  const handleRename = (e) => {
    e?.stopPropagation();
    setLoading(true);

    let main = isBlacklist ? editBlacklist : editList;
    main({ id: currentList.id, name: name })
      .then((res) => {
        setIsEdit(false);
        onRenamed?.();
        setListingLoad(true);
      })
      .finally(() => setLoading(false));
  };

  return (
    <Group h={40} ref={ref} pos={"relative"} className="hover-source" pr={32}>
      {isEdit ? (
        <TextInput
          placeholder="Nom"
          value={name}
          onChange={(e) => setName(e.target.value)}
          size="md"
          autoFocus
          rightSectionPointerEvents="all"
          rightSection={
            <ActionIcon onClick={handleRename} loading={loading}>
              <IconCheck />
            </ActionIcon>
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleRename();
            }
          }}
        />
      ) : (
        <Text size="lg" truncate maw={400}>{name}</Text>
      )}

      {!isEdit && (
        <ActionIcon
          variant="subtle"
          onClick={handleClick}
          pos={"absolute"}
          right={0}
          className="hover-target"
          size={"sm"}
        >
          <IconEdit size={16} />
        </ActionIcon>
      )}
    </Group>
  );
};

export default ListName;
